import { render, staticRenderFns } from "./EditableItem.vue?vue&type=template&id=bddf59dc"
import script from "./EditableItem.vue?vue&type=script&lang=ts"
export * from "./EditableItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports